// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__GaJjc","group":"Profile_group__8wTC7","line":"Profile_line__ox4Ad","name":"Profile_name__rG2KQ","value":"Profile_value__tJoPR"};